export function buildPaginationTokens(page, totalPages) {
  const safeTotal = Math.max(1, Number(totalPages) || 1)
  const safePage = Math.min(Math.max(1, Number(page) || 1), safeTotal)

  if (safeTotal <= 7) {
    return Array.from({ length: safeTotal }, (_, index) => index + 1)
  }

  const tokens = [1]
  const left = Math.max(2, safePage - 1)
  const right = Math.min(safeTotal - 1, safePage + 1)

  if (left > 2) tokens.push('ellipsis-left')
  for (let current = left; current <= right; current += 1) {
    tokens.push(current)
  }
  if (right < safeTotal - 1) tokens.push('ellipsis-right')

  tokens.push(safeTotal)
  return tokens
}
